import { render, staticRenderFns } from "./CredenciamentoAtualizacaoAcoesRefazer.vue?vue&type=template&id=4edae932"
import script from "./CredenciamentoAtualizacaoAcoesRefazer.vue?vue&type=script&lang=js"
export * from "./CredenciamentoAtualizacaoAcoesRefazer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports